<template>
  <div class="mt-8">
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title title="Detalhes da venda" class="mt-8">
      <template v-slot:before>
        <v-btn class="mb-1 mr-1" icon x-large color="primary"
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header-title>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && compra">
      <px-compra-pedido-header :compra="compra" @change="getCompra"/>
      <px-compra-dados-basicos :compra="compra"/>
      <px-compras-produtos class="mt-4" :compra="compra"/>
      <px-compras-produtos-pacotes class="mt-4" :compra="compra" @change="getCompra"/>
      <px-compra-mensagem class="mt-4" :compra="compra"/>
    </div>
  </div>
</template>

<script>
import CompraPedidoHeader from './CompraPedidoHeader.vue';
import CompraDadosBasicos from './CompraDadosBasicos.vue';
import ComprasProdutos from './ComprasProdutos.vue';
import ComprasProdutosPacotes from './ComprasProdutosPacotes.vue';
import CompraMensagem from './CompraMensagem.vue';
import CompraService from '../compras-service';

export default {
  data() {
    return {
      loading: false,
      compra: null,
      id: this.$route.params.id,
      breadcrumbs: [
        { text: 'Minhas compras' },
        { text: 'Compra' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.marketplace.vendas',
      });
    },
    getCompra() {
      this.loading = true;
      CompraService.getCompra(this.id)
        .then(({ data }) => {
          this.compra = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getCompra();
  },
  components: {
    pxCompraPedidoHeader: CompraPedidoHeader,
    pxCompraDadosBasicos: CompraDadosBasicos,
    pxComprasProdutos: ComprasProdutos,
    pxCompraMensagem: CompraMensagem,
    pxComprasProdutosPacotes: ComprasProdutosPacotes,
  },
};
</script>
